import React from "react";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { SiX } from "react-icons/si"; // X (formerly Twitter)
import { Link } from "react-router-dom";
import WhatsappQR from "../assets/images/Whatsapp QR Code_Full Pic.jpeg";
import WhatsappLogo from "../assets/images/whatsapplogo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* WhatsApp QR Section */}
        <div className="footer-section whatsapp-qr-section">
          <h2 style={{ display: "flex", alignItems: "center" }}>
            Connect with us on
            <img src={WhatsappLogo} alt="WhatsApp" style={{ marginLeft: "8px", width: "2rem", height: "2rem" }} />
          </h2>
          <div className="qr-container">
            <img src={WhatsappQR} alt="WhatsApp QR Code" className="footer-whatsapp-qr" />
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section links">
          <h2>Quick Links</h2>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/services">Our Services</Link>
            </li>
            <li>
              <Link to="/getinvolved">Get Involved</Link>
            </li>
            <li>
              <Link to="/contactus">Contact Us</Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section contact">
          <h2>Contact Us</h2>
          <p>
            <strong>Phone:</strong> 040-489-56302
          </p>
          <p>
            <strong>Email:</strong> hello@chauwk.com
          </p>
          <p>
            <strong>Address:</strong>
            <span className="footer-address">
              <br />T-Hub Phase 2 : Plot No 1/C, Sy No 83/1,
              <br />Raidurgam, Knowledge City Rd, Panmaktha,
              <br />Hyderabad, Telangana 500081
            </span>
          </p>
          <p>
            <strong>City:</strong> Hyderabad
          </p>
        </div>

        {/* Social Media */}
        <div className="footer-section social">
          <h2>Follow Us</h2>
          <div className="social-icons">
            <a
              href="https://facebook.com/Chauwk"
              target="_blank"
              rel="noopener noreferrer"
              title="Chauwk | Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://x.com/Chauwk1"
              target="_blank"
              rel="noopener noreferrer"
              title="Chauwk on X (formerly Twitter)"
            >
              <SiX />
            </a>
            <a
              href="https://www.instagram.com/chauwkidar/"
              target="_blank"
              rel="noopener noreferrer"
              title="Chauwk on Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/chauwk/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              title="Chauwk on LinkedIn"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Chauwk | All rights reserved |
        <Link
          to="/privacy-policy"
          style={{
            marginLeft: "5px",
            color: "#ffffff",
            textDecoration: "underline",
          }}
        >
          Privacy Policy
        </Link>
        <span style={{ margin: "0 6px" }}>|</span>
        <Link
          to="/terms-of-service"
          style={{
            color: "#ffffff",
            textDecoration: "underline",
          }}
        >
          Terms Of Service
        </Link>
        <span style={{ margin: "0 6px" }}>|</span>
        <Link
          to="/user-data-deletion"
          style={{
            color: "#ffffff",
            textDecoration: "underline",
          }}
        >
          User Data Deletion
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
